import React,{Component} from 'react';
import IconButton from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import ReactDOM from 'react-dom';
import CircularProgress from '@mui/material/CircularProgress';

class IconButtonFileUploader extends Component
{
    state=
    {
        uploading:false,
        file:"",
        fileName:""
    };
    
    openFileDialog =()=> {
        var fileInputDom = ReactDOM.findDOMNode(this.refs.fileUpload)
        fileInputDom.click()
      }
      handleFile=(event)=>
      {
        if(event.target.files&&event.target.files.length)
        {
            this.setState({fileName:event.target.files[0].name,uploading:true});
            const formData= new FormData();
            formData.append(this.props.name, event.target.files[0], event.target.files[0].name);
            this.props.onUpload(formData).then(uploadedFile=>this.setState({uploading:false}),error=>
                {
                    
                    this.setState({file:"",fileName:"",uploading:false});
                    this.props.onError();
                }).catch(error=>
                    {
                        
                        this.setState({file:"",fileName:"",uploading:false});
                        this.props.onError();
                    });
        }
      }
    render()
    {
        return (
            <span>
                <Tooltip title={this.props.label}>
                <IconButton onClick={this.openFileDialog} disabled={this.state.uploading||this.props.disabled}>
                    {!this.state.uploading&&!this.props.disabled&&this.props.children}
                    {(this.state.uploading||this.props.disabled)&&<CircularProgress size={20} />}
                </IconButton>
                </Tooltip>
                
              <input
                type='file'
                multiple={this.props.multi}
                ref='fileUpload'
                style={{ display: 'none' }}
                accept={this.props.accept}
                onChange={this.handleFile} />
            </span>
          );
    }
    
}

export default IconButtonFileUploader;